import { Injectable, inject } from '@angular/core';
import { catchError, of, switchMap, Observable } from 'rxjs';

import { ReportGroupFilterListingService } from 'src/app/services/api/report-group-filter/report-group-filter-listing.service';

import {
  FilterModel,
  FilterModels,
  ListingFiltersSource
} from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model.types';
import {
  FIELD_OPERATIONS_DATE_TIME,
  REASON,
  READING_RECEIVED,
  REPORT_GROUP,
  WAKE_UP_RECEIVED
} from './field-operations-listing.filters';

@Injectable()
export class FieldOperationsListingFiltersSourceService implements ListingFiltersSource {
  readonly reportGroupFilterService = inject(ReportGroupFilterListingService);

  readonly #applicable = 'AMI Health Dashboard';

  getAll(): Observable<FilterModels> {
    this.reportGroupFilterService.filter = REPORT_GROUP;
    return this.reportGroupFilterService.updateFilter(this.#applicable).pipe(
      switchMap(() => {
        return of([
          this.reportGroupFilterService.filter,
          FIELD_OPERATIONS_DATE_TIME,
          REASON,
          WAKE_UP_RECEIVED,
          READING_RECEIVED
        ]);
      }),
      catchError(error => {
        return of(error);
      })
    );
  }

  getReportGroup(): Observable<FilterModel> {
    return this.reportGroupFilterService.getFilter(this.#applicable);
  }
}
